import React from 'react'
import _ from 'underscore'
import { cn } from '@/lib/utils'

class TutorResultSubjectsPartial extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      expanded: false
    }
  }

  onExpandSubject = (e) => {
    this.setState({expanded: !this.state.expanded})
  }

  render() {
    let details = _.compact([this.props.tutor_subject.result, this.props.tutor_subject.syllabus]).join(', ')

    if (details.length > 0) {
      details = `(${details})`
    }

    return (
      <div
        className={cn(
          'mb-2 rounded-[10px] border bg-card',
          this.state.expanded ? 'border-primary/40 bg-primary/5' : 'border-border'
        )}
      >
        <button
          type="button"
          className="w-full cursor-pointer rounded-[10px] px-4 py-3 text-left text-sm font-medium hover:bg-muted/50"
          onClick={this.onExpandSubject}
        >
          {this.props.tutor_subject.subject_name} - {this.props.tutor_subject.subject_level_name} {this.props.tutor_subject.subject_category_name} {details}
        </button>
        {this.state.expanded ?
          <div className="border-t border-border px-4 py-3 text-sm">
            <span className="font-semibold">Justification: </span><span>{this.props.tutor_subject.justification}</span>
          </div>
          : null
        }
      </div>
    )
  }
}

export default TutorResultSubjectsPartial
